import { render, staticRenderFns } from "./house-building-list.vue?vue&type=template&id=2f1fe30a"
import script from "./house-building-list.vue?vue&type=script&lang=ts"
export * from "./house-building-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports